import script from "./funnel.vue?vue&type=script&setup=true&lang=js"
export * from "./funnel.vue?vue&type=script&setup=true&lang=js"

import "./funnel.vue?vue&type=style&index=0&id=34036a3e&lang=scss&scoped=true"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34036a3e"]])

export default __exports__